import 'devextreme/dist/css/dx.light.css';
import 'devexpress-gantt/dist/dx-gantt.min.css';
import React from 'react';
import './App.css';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import AppRoutes from './routes/AppRoutes';
import { theme } from './styles/GlobalStyle';

function App() {
  return (
    <React.Fragment>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider maxSnack={10} anchorOrigin={{vertical: 'top',horizontal: 'right'}}>
        <AppRoutes />
      </SnackbarProvider>
    </ThemeProvider>
  </React.Fragment>
  );
}

export default App;
